export const getUrlParam = (name: string, url: string) => {
  // eslint-disable-next-line
  const replacedName = name?.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  const regexS = "[\\?&]" + replacedName + "=([^&#]*)";
  const regex = new RegExp(regexS);
  const results = regex.exec(url);
  return results == null ? null : results[1];
};
